import { createContext } from 'react'

import { noop } from '@/lib/utils/function'

export const RegisterCaseDialogContext = createContext<{
  closeDialog: VoidFunction
}>({
  closeDialog: noop,
})
